import {TPrescriptionFields} from "../../../../../types/prescription";
import VisitInsurerPricing from "./visitInsurerPricing";

type VisitPricingAndPrescriptionDetailsProps = {
    checkInsuranceData: any;
    prescriptionData: TPrescriptionFields;
}


const VisitPricingAndPrescriptionDetails = ({
    checkInsuranceData,
    prescriptionData,
}:VisitPricingAndPrescriptionDetailsProps) => {

    return (
        <div className={'w-100 d-flex flex-column justify-content-around align-items-center rounded rounded-4 border border-gray-300 bg-white mt-3'}>
            <VisitInsurerPricing
                checkInsuranceData={checkInsuranceData}
            />
            {/*<VisitPrescriptionDetails*/}
            {/*    prescriptionData={prescriptionData}*/}
            {/*    getPrescriptionRequest={getPrescriptionRequest}*/}
            {/*/>*/}
        </div>
    )
}


export default VisitPricingAndPrescriptionDetails;